import React from 'react';
import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import { useAppStore } from 'stores/appStore';
import { useMockupStore } from 'stores/mockupStore';
import styles from '../ExistingSiteStoreReadyStep.scss';

interface ExistingSiteStoreReadyMockupsPanelProps {
  /** Two-column grid for the "page ready" task preview. */
  gridVariant?: 'default' | 'two-column';
}

/** Merchant-facing preview tiles (no faux shopper buy row). */
export function ExistingSiteStoreReadyMockupsPanel({
  gridVariant = 'default',
}: ExistingSiteStoreReadyMockupsPanelProps) {
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const mockups = useMockupStore((state) => state.mockups);
  const isLoading = useMockupStore((state) => state.isLoading);

  const gridClassName =
    gridVariant === 'two-column'
      ? styles.existingSiteStoreReadyMockupsGridTwoColumn
      : styles.existingSiteStoreReadyMockupsGrid;

  return (
    <div className={styles.existingSiteStoreReadyMockups}>
      <div className={gridClassName}>
        {selectedProducts.map((product) => {
          const mockupUrl = mockups[product.id]?.url;

          return (
            <div key={product.id} className={styles.existingSiteStoreReadyMockupsItem}>
              <ProductCard
                imageUrl={mockupUrl ?? product.mockupImageUrl}
                isLoading={isLoading && !mockupUrl}
                name={product.name}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
